// 対応している言語。韓国語・ルーマニア語を足すときは、ここと src/shared/content/ と src/client/ui.ts に足す

export const LOCALES = ["ja", "en"] as const;
export type Locale = (typeof LOCALES)[number];

export const DEFAULT_LOCALE: Locale = "ja";

/** 言語メニューに出す名前 (その言語自身の書き方) */
export const LOCALE_NAMES: Record<Locale, string> = {
  ja: "日本語",
  en: "English",
};

/** 日付の表示などに使う BCP 47 の言語タグ */
export const LOCALE_TAGS: Record<Locale, string> = {
  ja: "ja-JP",
  en: "en-US",
};

export const isLocale = (value: unknown): value is Locale => LOCALES.includes(value as Locale);

/** "en-US" や "ja" のような言語タグから、対応している言語を選ぶ。合わなければ null */
export function matchLocale(tag: string | null | undefined): Locale | null {
  const base = (tag ?? "").toLowerCase().split(/[-_]/)[0];
  return isLocale(base) ? base : null;
}
